import { Grade } from '@/pages/AccountInformation/AccountInformation.types';
import { grades as gradeOptions } from '@/pages/AccountInformation/AccountInformation.constants';

export const getGradeRange = (lowGrade: string, highGrade: string): Grade[] => {
  const lowIndex = gradeOptions.findIndex(g => g.description === lowGrade);
  const highIndex = gradeOptions.findIndex(g => g.description === highGrade);

  if (lowIndex === -1 || highIndex === -1) return [];

  const start = Math.min(lowIndex, highIndex);
  const end = Math.max(lowIndex, highIndex);

  return gradeOptions.slice(start, end + 1);
};
